import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Comments types.
 *
 * Perechile vechi: `settings/easeedesk/comments_settings`,
 * `get_comment_type_list`, `create_comment_type`, `update_comment_type`,
 * `delete_comment_type`, `change_comment_type_status`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface CommentTypeRow {
  ID: number
  comment_name: string
  /** 1 = rand comun tuturor instantelor; nu se redenumeste si nu se sterge. */
  default: number
  scheme_id: number
  active: number
  type_color: string
}

export interface CommentTypesList {
  default_comment_types: CommentTypeRow[]
  comment_types: CommentTypeRow[]
}

export interface CommentTypesShell {
  title: string
  moduleUrl: string
}

export function commentTypesShellQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'comment_types'],
    queryFn: () => apiGet<CommentTypesShell>('/settings/easeedesk/comment_types'),
  })
}

export function commentTypesListQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'comment_types', 'list'],
    queryFn: () => apiGet<CommentTypesList>('/settings/easeedesk/comment_types/list'),
  })
}

export function createCommentType(type_name: string, type_color: string) {
  return apiPost<{ ok?: boolean; ID?: number }>('/settings/easeedesk/comment_types', { type_name, type_color })
}

export function updateCommentType(type: number, type_name: string, type_color: string) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/comment_types/${type}`, { type_name, type_color })
}

export function changeCommentTypeStatus(type: number, on: boolean) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/comment_types/${type}/status`, {
    type_status: on ? 'on' : 'off',
  })
}

export function removeCommentType(type: number) {
  return apiPost<{ ok?: boolean }>(`/settings/easeedesk/comment_types/${type}/remove`, {})
}
